import { createPortal } from 'react-dom'
import { useEffect } from 'react'
import Select from 'react-select'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import { usePileStore } from 'Store/Pile'
import { shallow } from 'zustand/shallow'

interface Props {
  open: boolean
  handleClose: () => void
  formType: 'create' | 'edit'
  formState: any
  onChange: (name: string, value: any) => void
  onSubmit: () => Promise<void>
  errorItem: any
}

const ItemForm: React.FC<Props> = ({
  open,
  handleClose,
  formState,
  formType,
  onChange,
  onSubmit,
  errorItem,
}) => {
  const modalsRoot = document.getElementById('root-modals') || document.body
  // const [hasType, setHasType] = useState(false)
  const { piles, getPile, clearStatePile } = usePileStore(
    state => ({
      piles: state.data,
      getPile: state.getAll,
      clearStatePile: state.clearState,
    }),
    shallow
  )
  const pileOptions = piles.map((p: any) => ({
    label: p.itemCode,
    value: p.itemCode,
  }))

  // const onSearchCode = (val: string, callback: (options: any[]) => void) => {
  //   if (formType === 'edit' && hasType === false) {
  //     setHasType(true)
  //   }

  //   if (val.length >= 3) {
  //     const options = MasterPileData.filter(item => item.code.includes(val)).map(item => ({
  //       label: item.code,
  //       value: item.code,
  //     }))
  //     callback(options)
  //   }

  //   callback([])
  // }

  const onChangeCode = (val: any) => {
    const item = piles.find(item => item.itemCode === val)

    onChange('itemTitle', item?.itemTitle)
    onChange('itemCode', item?.itemCode)
  }

  // const onChangeGroupLetter = (val: string) => {
  //   // allow only 1 letter
  //   // if (val.length > 1) {
  //   //   return
  //   // }
  //   onChange('groupLetter', val)
  // }

  useEffect(() => {
    if (open) {
      getPile()
    } else {
      clearStatePile()
    }
    // eslint-disable-next-line
  }, [open])

  return createPortal(
    <Modal
      id='kt_modal_sale_order_import'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-900px'
      show={open}
      onHide={handleClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>{formType === 'create' ? 'เพิ่มรายการเสา' : 'แก้ไขรายการเสา'}</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-400px'>
          <div className='row gy-5'>
            <div className='col-12'>
              <label className='mb-2'>
                อันดับ <span className='required' />
              </label>
              <input
                type='text'
                className='form-control form-control-sm'
                defaultValue={formState.sequence}
                onChange={(e: any) => onChange('sequence', e.target.value)}
                style={{
                  borderColor: errorItem.sequence ? '#FD397A' : '',
                }}
              />
            </div>

            <div className='col-12'>
              <label className='mb-2'>
                รหัสเสา <span className='required' />
              </label>
              <Select
                options={pileOptions}
                value={pileOptions.find(o => o.value === formState.itemCode)}
                onChange={(val: any) => onChangeCode(val?.value)}
              />
              {/* <AsyncSelect
                cacheOptions
                loadOptions={onSearchCode}
                onChange={(val :any) => val && onChangeCode(val.value)}
                defaultValue={
                  formType === 'edit' && hasType === false
                    ? { label: formState.itemCode, value: formState.itemCode }
                    : null
                }
                placeholder='กรุณากรอก Code ของเสาอย่างน้อย 3 ตัวอักษร เช่น A13'
              /> */}
            </div>

            <div className='col-12'>
              <label className='mb-2'>
                ชื่อเสา <span className='required' />
              </label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={formState.itemTitle}
                disabled
                style={{
                  borderColor: errorItem.itemTitle ? '#FD397A' : '',
                }}
              />
            </div>

            <div className='col-12'>
              <label className='mb-2'>
                วิธีการตอก <span className='required' />
              </label>
              <input
                className='form-control form-control-sm'
                value={formState.hammerMethod}
                onChange={(e: any) => onChange('hammerMethod', e.target.value)}
                style={{
                  borderColor: errorItem.hammerMethod ? '#FD397A' : '',
                }}
              />
              {/* <div className='form-check form-check-custom form-check-solid mb-5 cursor-pointer'>
                <input
                  className='form-check-input'
                  type='radio'
                  value=''
                  id='pileType1'
                  checked={formState?.hammerMethod === 'ปั้นจั่น'}
                />
                <label className='form-check-label text-black' htmlFor='pileType1'>
                  ปั้นจั่น
                </label>
              </div>
              <div className='form-check form-check-custom form-check-solid cursor-pointer'>
                <input
                  className='form-check-input'
                  type='radio'
                  value=''
                  id='pileTyp2'
                  checked={formState?.hammerMethod === 'PD'}
                />
                <label className='form-check-label text-black' htmlFor='pileTyp2'>
                  PD
                </label>
              </div> */}
            </div>

            <div className='col-12'>
              <label className='mb-2'>
                จำนวนเสา <span className='required' />
              </label>
              <input
                type='text'
                className='form-control form-control-sm'
                defaultValue={formState.quantity}
                onChange={(e: any) => onChange('quantity', e.target.value)}
                style={{
                  borderColor: errorItem.quantity ? '#FD397A' : '',
                }}
              />
            </div>
            <div className='col-12'>
              <label className='mb-2'>
                ความยาวใช้จริง <span className='required' />
              </label>
              <input
                type='text'
                className='form-control form-control-sm'
                defaultValue={formState.actualQuantity}
                onChange={(e: any) => onChange('actualQuantity', e.target.value)}
                style={{
                  borderColor: errorItem.actualQuantity ? '#FD397A' : '',
                }}
              />
            </div>

            {/* <div className='col-12'>
              <label className='mb-2'>
                รหัสกลุ่มเสา <span className='required' />
              </label>
              <input
                type='text'
                className='form-control form-control-sm'
                placeholder='A,B,C ..'
                defaultValue={formState.groupLetter}
                onChange={(e:any) => onChangeGroupLetter(e.target.value)}
                style={{
                  borderColor: errorItem.groupLetter ? '#FD397A' : '',
                }}
              />
            </div> */}
            <div className='col-12'>
              <label className='mb-2'>โรงงาน</label>
              <input
                type='text'
                className='form-control form-control-sm'
                placeholder='A,B,C'
                defaultValue={formState.factory}
                onChange={(e: any) => onChange('factory', e.target.value)}
                style={{
                  borderColor: errorItem.factory ? '#FD397A' : '',
                }}
              />
            </div>

            <div className='col-12'>
              <label className='mb-2'>Safe Load</label>
              <input
                type='text'
                className='form-control form-control-sm'
                placeholder=''
                defaultValue={formState.safeLoad}
                onChange={(e: any) => onChange('safeLoad', e.target.value)}
                style={{
                  borderColor: errorItem.safeLoad ? '#FD397A' : '',
                }}
              />
            </div>

            <div className='col-12'>
              <label className='mb-2'>Ps</label>
              <input
                type='text'
                className='form-control form-control-sm'
                placeholder=''
                defaultValue={formState.ps}
                onChange={(e: any) => onChange('ps', e.target.value)}
                style={{
                  borderColor: errorItem.ps ? '#FD397A' : '',
                }}
              />
            </div>

            <div className='col-12'>
              <label className='mb-2'>หมายเหตุ</label>
              <textarea
                className='form-control form-control-sm'
                placeholder=''
                defaultValue={formState.remark}
                onChange={(e: any) => onChange('remark', e.target.value)}
                style={{
                  borderColor: errorItem.remark ? '#FD397A' : '',
                }}
              />
            </div>
          </div>
        </div>

        <div className='modal-footer'>
          <button type='button' className='btn btn-sm btn-light' onClick={handleClose}>
            ยกเลิก
          </button>
          <button type='button' className='btn btn-sm btn-primary' onClick={onSubmit}>
            บันทึก
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default ItemForm
